export {
  SessionProvider,
  useSession,
  getSessionToken,
  setSessionToken,
  clearSessionToken,
  setImpersonatorToken,
  type SessionUser,
  type SessionAgent,
  type SessionState,
} from "../context/SessionContext";

const REFERRAL_CODE_KEY = "aam_referral_code";

export function getStoredReferralCode(): string | null {
  return sessionStorage.getItem(REFERRAL_CODE_KEY);
}

export function setStoredReferralCode(code: string) {
  sessionStorage.setItem(REFERRAL_CODE_KEY, code.trim().toUpperCase());
}

export function clearStoredReferralCode() {
  sessionStorage.removeItem(REFERRAL_CODE_KEY);
}
